import type { ErrorMessage } from '@repo/types/messages/error';

import { CircleSlash } from 'lucide-react';

import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface FilesPageErrorProps {
  errorMessage?: ErrorMessage;
}

export default function FilesPageError(filesPageErrorProps: FilesPageErrorProps) {
  const { errorMessage } = filesPageErrorProps;
  return (
    <EmptyState>
      <EmptyStateCircles className={'z-0'} />
      <FeaturedIcon size={'lg'} className={'z-10'}>
        <CircleSlash />
      </FeaturedIcon>
      <EmptyStateContent>
        <EmptyStateTitle>{errorMessage?.title || 'Wystąpił błąd'}</EmptyStateTitle>
        <EmptyStateDescription>{errorMessage?.detail || 'Podczas ładowania zawartości folderu wystąpił nieoczekiwany błąd.'}</EmptyStateDescription>
      </EmptyStateContent>
    </EmptyState>
  );
}
